module.exports = __webpack_public_path__ + "static/img/acdc.2186a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patrocinio/acdc.png
// module id = HXTo
// module chunks = 1